import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getIn, useFormikContext } from 'formik'

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/extensions */
import { CustomerFormModel, DocType } from '../../model/customer.model'
import { setFields } from '../../store/customer.reducer'
import { selectCustomerInfoProps } from '../../store/customer.selectors'

import useValidateForm from '~/sale/hooks/useValidateForm'
import { setFormValidity } from '~/sale/store'

export default function useCustomerInfoForm() {
  const {
    values,
    errors,
    touched,
    setStatus,
    setFieldValue,
    status,
    isValid,
  } = useFormikContext<CustomerFormModel>()

  const isDocValid = !getIn(status, 'docId.error')

  const dispatch = useDispatch()

  const { isCompanySegment, docType } = useSelector(selectCustomerInfoProps)
  const { customerSegment, nationality } = values

  const segmentError = useMemo(
    () => getIn(touched, 'customerSegment') && getIn(errors, 'customerSegment'),
    [touched, errors],
  )

  useValidateForm({
    lineId: 'mainLine',
    form: 'customer',
    isValidForm: isValid && isDocValid,
    refreshValue: isDocValid,
  })

  const setFieldsValues = useCallback(() => {
    dispatch(setFields(values))
  }, [setStatus, values])

  useEffect(() => {
    if (docType === DocType.NIF && nationality !== 'España') {
      setFieldValue('nationality', 'ESPAÑA')
    }
  }, [docType, nationality])

  useEffect(() => {
    setFieldsValues()
  }, [values])

  useEffect(() => {
    dispatch(
      setFormValidity({ lineId: 'mainLine', form: 'customer', isValid: isValid && isDocValid }),
    )
  }, [isValid, isDocValid])

  return { customerSegment, segmentError, isCompanySegment, docType }
}
